<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PERFILRIESGO.LBL_INFOPERFIL' | translate}}" *ngIf="perfil">
        <div class="grid">
          <div class="lg:col-2 md:col-2 col-12 text-center">
            <img *ngIf="imagen" style="height: 100px" [src]="imagen" alt=""/>
            <div *ngIf="!imagen">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_CARGANDO' | translate }}</span>
            </div>
          </div>
          <div class="lg:col-10 md:col-10 col-12">
            <div class="grid">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_CODIGO' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8 "><strong>{{perfil.codigo}}</strong></label>
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_NOMBRERIESGO' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{perfil.nombreRiesgo}}</strong></label>
            </div>
            <div class="grid">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_DESCRIPCION' | translate }}:</label>
              <label class="lg:col-9 col-6 md:col-8"><strong>{{perfil.descripcion}}</strong></label>
            </div>
            <div class="grid">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_RANGOSCORE' | translate }}:</label>
              <label
                class="lg:col-3 col-6 md:col-8"><strong>{{(perfil.rangoMinimo && perfil.rangoMaximo) ? (perfil.rangoMinimo + ' a ' + perfil.rangoMaximo) : ''}}</strong></label>
            </div>
            <div class="grid">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_MANEJACICLOS' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{perfil.indicadorManejaCiclos ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</strong></label>
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{perfil.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</strong></label>
            </div>
            <div class="grid">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_CONSULTAAUTO' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{perfil.indicadorConsultaAutomatica ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</strong></label>
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PERFILRIESGO.LBL_CAMBIOESTADO' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8"><strong>{{perfil.indicadorCambioEstado ? ('LBL_SI' | translate) : ('LBL_NO' |
                translate)}}</strong></label>
            </div>
          </div>
        </div>

      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PERFILRIESGO.LBL_ASIGNARTASA' | translate}}">
        <p-table [columns]="colTasas"
                 [value]="perRiesgoTasas" selectionMode="single" dataKey="idPerfilRiesgoVariacionMonto"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreModalidad}}</td>
              <td>{{row.tasaModalidad}}</td>
              <td>{{row.tasaPeriodica | numero:6}}</td>
              <td>{{row.indicadorSuma ? '+' : '-'}}{{row.puntosDisminucion}}</td>
              <td>{{row.montoMinimo}}</td>
              <td>{{row.montoMaximo}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PERFILRIESGO.LBL_ASIGNARCICLO' | translate}}">
        <p-table [columns]="colCiclos"
                 [value]="perRiesgoCiclos" selectionMode="single" dataKey="idPerfilRiesgoVariacionCiclo"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.id}}</td>
              <td>{{row.nombreModalidad}}</td>
              <td>{{row.cicloPerfilRiesgo}}</td>
              <td>{{row.indicadorSuma ? '+' : '-'}}{{row.puntosDisminucion}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PERFILRIESGO.LBL_ASIGNARSCORE' | translate}}">
        <app-asignar-score [perfil]="perfil" *ngIf="perfil && perfil.idPerfilRiesgo" [editando]="true"></app-asignar-score>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
